let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4aLlP"), load("56uR7"), load("iTmpz")]).then(() => parcelRequire('l5vdF'));